import { render, staticRenderFns } from "./PayrollHistoryCancelModal.vue?vue&type=template&id=2101b29c&"
import script from "./PayrollHistoryCancelModal.vue?vue&type=script&lang=js&"
export * from "./PayrollHistoryCancelModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports